import axios from 'axios'
import { fetchIfNeededWrapper, fetchWrapper } from '@/reducers/fetch'
import { setPermissions } from '../reducers/auth/securityReducer'

export enum ProductFeatureId {
  annualTaxes = 'annual_taxes',
  annualTaxesBusinessFiling = 'annual_taxes_business_filing',
  free2ndTaxFiling = 'free_2nd_tax_filing',
  groupPracticeSupport = 'group_practice_support',
  payroll = 'payroll',
  payrollIncludedForFreeForSelf = 'payroll_included_for_free_for_self',
  phoneSupport = 'phone_support',
  quarterlyTaxes = 'quarterly_taxes',
  sCorpEligibilitySupport = 's_corp_eligibility_support',
  sCorpComplianceSupport = 's_corp_compliance_support',
  taxConsultation = 'tax_consultation',
  taxConsultationIncludedForFree = 'tax_consultation_included_for_free',
}

export const FETCH_USER_PERMISSIONS_KEY = 'FETCH_USER_PERMISSIONS_KEY'
export const getUserPermissions = () =>
  fetchIfNeededWrapper({
    fetchKey: FETCH_USER_PERMISSIONS_KEY,
    fetchFunction: async (dispatch) => {
      const res = await axios.get<ProductFeatureId[]>(
        '/finances/api/v2/permissions/user'
      )
      dispatch(setPermissions(res.data))
      return res.data
    },
  })

export const FETCH_PRODUCT_PERMISSIONS_KEY = 'FETCH_PRODUCT_PERMISSIONS_KEY'
export const getProductPermissions = ({
  productIds,
}: {
  productIds: string[] | undefined
}) =>
  fetchWrapper({
    fetchKey: FETCH_PRODUCT_PERMISSIONS_KEY,
    fetchFunction: async () => {
      if (!productIds || productIds.length === 0) {
        return {}
      }
      const res = await axios.get<Record<string, ProductFeatureId[]>>(
        `/finances/api/v2/permissions/product?productIds=${productIds.join(',')}`
      )
      return res.data
    },
  })
